
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ads/jp-cc1",
      function () {
        return require("private-next-pages/ads/jp-cc1.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ads/jp-cc1"])
      });
    }
  